import React from "react"
import { Container } from "reactstrap"
import ApiRest from "../../ayudas/apiRest"
import toastr from "toastr"
import Breadcrumbs from "../../components/Common/Breadcrumb"

const styles = {
  wrapper: {
    minHeight: "80vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 20px",
  },
  card: {
    background: "linear-gradient(135deg, #293042 0%, #1a2035 60%, #0f1520 100%)",
    borderRadius: "24px",
    padding: "60px 50px",
    maxWidth: "780px",
    width: "100%",
    textAlign: "center",
    position: "relative",
    overflow: "hidden",
    boxShadow: "0 30px 80px rgba(0,0,0,0.45), 0 0 0 1px rgba(255,255,255,0.06)",
  },
  glow1: {
    position: "absolute",
    top: "-80px",
    right: "-80px",
    width: "280px",
    height: "280px",
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(99,179,237,0.18) 0%, transparent 70%)",
    pointerEvents: "none",
  },
  glow2: {
    position: "absolute",
    bottom: "-60px",
    left: "-60px",
    width: "220px",
    height: "220px",
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(159,122,234,0.15) 0%, transparent 70%)",
    pointerEvents: "none",
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    background: "rgba(99,179,237,0.12)",
    border: "1px solid rgba(99,179,237,0.35)",
    borderRadius: "999px",
    padding: "6px 18px",
    marginBottom: "28px",
    animation: "fadeSlideDown 0.6s ease both",
  },
  badgeDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    background: "#63b3ed",
    display: "inline-block",
    animation: "pulse 1.6s ease-in-out infinite",
  },
  badgeText: {
    color: "#63b3ed",
    fontSize: "12px",
    fontWeight: "600",
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    margin: 0,
  },
  icon: {
    fontSize: "64px",
    marginBottom: "20px",
    display: "block",
    animation: "bounceIn 0.8s ease both 0.2s",
    filter: "drop-shadow(0 4px 16px rgba(99,179,237,0.4))",
  },
  title: {
    color: "#ffffff",
    fontSize: "36px",
    fontWeight: "800",
    lineHeight: "1.2",
    marginBottom: "8px",
    animation: "fadeSlideUp 0.7s ease both 0.3s",
    letterSpacing: "-0.5px",
  },
  subtitle: {
    color: "#63b3ed",
    fontSize: "20px",
    fontWeight: "600",
    marginBottom: "24px",
    animation: "fadeSlideUp 0.7s ease both 0.4s",
  },
  divider: {
    height: "1px",
    background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.12), transparent)",
    margin: "28px 0",
    animation: "fadeIn 0.8s ease both 0.5s",
  },
  description: {
    color: "rgba(255,255,255,0.72)",
    fontSize: "16px",
    lineHeight: "1.8",
    marginBottom: "32px",
    animation: "fadeSlideUp 0.7s ease both 0.5s",
  },
  button: {
    display: "inline-flex",
    alignItems: "center",
    gap: "10px",
    background: "linear-gradient(135deg, #4299e1 0%, #3182ce 100%)",
    color: "#ffffff",
    fontSize: "16px",
    fontWeight: "700",
    padding: "16px 40px",
    borderRadius: "14px",
    border: "none",
    cursor: "pointer",
    textDecoration: "none",
    letterSpacing: "0.3px",
    boxShadow: "0 8px 24px rgba(66,153,225,0.45), inset 0 1px 0 rgba(255,255,255,0.2)",
    transition: "transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease",
    animation: "fadeSlideUp 0.7s ease both 0.7s, shimmer 3s ease-in-out infinite 1.5s",
  },
  footer: {
    marginTop: "32px",
    color: "rgba(255,255,255,0.35)",
    fontSize: "12px",
    animation: "fadeIn 1s ease both 0.9s",
  },
}

const keyframes = `
@keyframes fadeSlideDown {
  from { opacity: 0; transform: translateY(-16px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes fadeSlideUp {
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes fadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}
@keyframes bounceIn {
  0%   { opacity: 0; transform: scale(0.4); }
  60%  { transform: scale(1.12); }
  80%  { transform: scale(0.96); }
  100% { opacity: 1; transform: scale(1); }
}
@keyframes pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50%       { opacity: 0.5; transform: scale(0.85); }
}
@keyframes floatCard {
  0%, 100% { transform: translateY(0px); }
  50%       { transform: translateY(-6px); }
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
@keyframes orbitRing {
  0%   { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}
`

export default class Dashboard extends React.Component {

  constructor(props) {
    super(props);
    this.apiRest = new ApiRest(props);
    this.btnRef = React.createRef();
    this.state = { btnHover: false };
  }

  componentDidMount() {
    this.getCenter();
    this.interval = setInterval(this.getCenter, 60000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  getCenter = () => {
    let user = this.apiRest.getLS('du');
    if (user !== undefined && user !== null) {
      try {
        this.apiRest.get('/solicitudConcurrente_detail').then(res => {
          if (res.exitoso) {
            if (res.data != 0) {
              toastr.warning('Se Realizo una Nueva Solicitud Concurrente');
            }
          } else {
            if (res.status === 401) {
              this.props.history.push('/Timeout');
            }
          }
        });
      } catch (error) {
        console.log(error)
      }
    }
  }

  render() {
    const { btnHover } = this.state;

    const buttonStyle = {
      ...styles.button,
      ...(btnHover ? {
        transform: "translateY(-3px) scale(1.03)",
        boxShadow: "0 14px 32px rgba(66,153,225,0.6), inset 0 1px 0 rgba(255,255,255,0.2)",
        background: "linear-gradient(135deg, #4facfe 0%, #3182ce 100%)",
      } : {}),
    };

    return (
      <React.Fragment>
        <style>{keyframes}</style>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Xelapan" breadcrumbItem="Inicio" />

            <div style={styles.wrapper}>
              <div style={{ ...styles.card, animation: "floatCard 5s ease-in-out infinite" }}>

                {/* Orbes decorativos */}
                <div style={styles.glow1} />
                <div style={styles.glow2} />

                {/* Anillo decorativo superior */}
                <div style={{
                  position: "absolute",
                  top: "30px",
                  right: "30px",
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  border: "2px dashed rgba(99,179,237,0.2)",
                  animation: "spin 12s linear infinite",
                  pointerEvents: "none",
                }} />

                {/* Badge de novedad */}
                <div style={styles.badge}>
                  <span style={styles.badgeDot} />
                  <span style={styles.badgeText}>Nuevo Anuncio</span>
                </div>

                {/* Ícono principal */}
                <span style={styles.icon}>🚀</span>

                {/* Títulos */}
                <h1 style={styles.title}>Nueva Mesa de Servicio</h1>
                <p style={styles.subtitle}>Plataforma MIX4</p>

                <div style={styles.divider} />

                {/* Descripción */}
                <p style={styles.description}>
                  Nos complace anunciar el lanzamiento de nuestra <strong style={{ color: "#fff" }}>nueva Mesa de Servicio</strong> en
                  la plataforma <strong style={{ color: "#63b3ed" }}>MIX4</strong>. Ahora puedes gestionar tus solicitudes,
                  reportar incidencias y dar seguimiento a tus tickets de manera más eficiente,
                  rápida y segura desde un solo lugar.
                </p>                

                {/* Botón CTA */}
                <a
                  href="https://mix4.xelapan.net/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={buttonStyle}
                  onMouseEnter={() => this.setState({ btnHover: true })}
                  onMouseLeave={() => this.setState({ btnHover: false })}
                >
                  <span style={{ fontSize: "20px" }}>🌐</span>
                  Ir a MIX4 ahora
                  <span style={{
                    display: "inline-flex",
                    transition: "transform 0.2s ease",
                    transform: btnHover ? "translateX(4px)" : "translateX(0)",
                    fontSize: "18px",
                  }}>→</span>
                </a>

                {/* Footer */}
                <p style={styles.footer}>
                  mix4.xelapan.net &nbsp;·&nbsp; Xelapan ERP &nbsp;·&nbsp; {new Date().getFullYear()}
                </p>
              </div>
            </div>

          </Container>
        </div>
      </React.Fragment>
    )
  }
}
